import React, { useState } from "react";
import "./headboard.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import {
  normalizeTwoWords,
  findTarget,
  findRel,
  OptimizeImage,
} from "../../../shared/utils/stringUtilities";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import Img from "gatsby-image";
import { Link } from "gatsby"
// import Author from "../../molecules/author/author";
// import { adapterAuthor } from "../../templates/library-components/adapters";
import ShareModal from "../../molecules/ShareModal/ShareModal";
import Button from "../../atoms/button/button";
import { RiShareForwardFill } from "react-icons/ri";

const Headboard = (props: ReferenciaCabecera) => {
  const data = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };
  
  return (
    <div className="o-headboard">
      <ShareModal
        open={isModalVisible}
        onClose={toggleModal}
        gtmClass={`gtm${normalizeTwoWords(
          props.tituloPrincipal
        )}Articulo${normalizeTwoWords(props.tituloPrincipal)}Compartir`}
      />
      <div className="o-headboard__container">
        <div className="o-headboard__container__content">
          <Breadcrumb content={data.migaDePan} />
          <Link to={data.slug}>
            <h1 className="o-headboard__container__content__title" dangerouslySetInnerHTML={{ __html: data.tituloPrincipal }}>
            </h1>
          </Link>
          {data.referenciaTags && (
            <div className="o-headboard__container__content__tags">
              {data.referenciaTags.map((value, index) => (
                <a
                  key={index}
                  className={`o-headboard__container__content__tags__tag gtm${normalizeTwoWords(
                    data.tituloPrincipal
                  )}Tag${normalizeTwoWords(value.nombreTag)}`}
                  title={value.nombreTag}
                  href={value.slugSubcategorias}
                  target={findTarget(value.slugSubcategorias)}
                  rel={findRel(value.slugSubcategorias)}
                >
                  {value.nombreTag}
                </a>
              ))}
            </div>
          )}
          {/* <Author {...adapterAuthor(data.referenciaAutor)} /> */}
          <div className="o-headboard__container__content__btns">
            <Button
              onClickAction={toggleModal}
              text=" compartir"
              isDisabled={false}
              classname="o-headboard__container__content__btns__btn"
              IconAlt={<RiShareForwardFill />}
              type="button"
            />
          </div>
        </div>
        {data.imagenHeader ? (
          <div className="o-headboard__container__cover">
            {data.imagenHeader.fluid ? (
              <Img
                className="o-headboard__container__cover__img"
                fluid={data.imagenHeader.fluid}
                alt={data.imagenHeader.title || "imagen cabecera botones"}
              />
            ) : (
              <img
                className="o-headboard__container__cover__img"
                src={OptimizeImage(
                  data.imagenHeader.file.url,
                  data.imagenHeader.file.contentType,
                  550
                )}
                alt={
                  (data.imagenHeader && data.imagenHeader.title) ||
                  "imagen cabecera"
                }
                loading="lazy"
              />
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Headboard;
